import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MaskType } from "src/app/constants/masks";
import { SessionService } from "src/app/services/storage/session.service";
import { MemberSearchPayload } from "src/app/models/member-lookup";
import { FormValidationService } from "src/app/services/form-validation.service";
import { AgentCompany } from "src/app/models/agent";

@Component({
    selector: 'mwp-member-search-form',
    templateUrl: './member-search-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberSearchFormComponent implements OnInit {
    @Input() public isTestMemberSearch: boolean;
    @Output() public emitSearchPayload: EventEmitter<MemberSearchPayload> = new EventEmitter<MemberSearchPayload>();

    public maskType = MaskType;
    public companySearchForm: FormGroup;
    public memberSearchForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private sessionService: SessionService,
    ) {
    }

    ngOnInit() {
        if (this.isTestMemberSearch)
            this.companySearchForm = this.formBuilder.group({
                companyName: [null],
                companyID: [null],
            }, { validators: FormValidationService.formHasAtLeastOneValue });
        else
            this.companySearchForm = this.formBuilder.group({
                companyName: [null],
                companyID: [null],
            });

        this.memberSearchForm = this.formBuilder.group({
            lastName: [''],
            firstName: [''],
            erid: [''],
            systemId: [''],
            ssn: ['', FormValidationService.validSSN(false)],
            last4SSN: ['', FormValidationService.validLast4SSN(false)],
        }, { validators: FormValidationService.formHasAtLeastOneValue });
    }

    public searchByCompany(company: AgentCompany) {
        if (this.isTestMemberSearch) {
            const l_MemberSearchPayload = new MemberSearchPayload();
            l_MemberSearchPayload.agentID = this.sessionService.session.agent.agentID;
            l_MemberSearchPayload.isPrimaryQ = true;
            l_MemberSearchPayload.companyID = this.companySearchForm.get('companyID').value ? this.companySearchForm.get('companyID').value : 0;

            this.emitSearchPayload.emit(l_MemberSearchPayload);

            this.memberSearchForm.get('lastName').setValue('');
            this.memberSearchForm.get('firstName').setValue('');
            this.memberSearchForm.get('erid').setValue('');
            this.memberSearchForm.get('systemId').setValue('');
            this.memberSearchForm.get('ssn').setValue('');
            this.memberSearchForm.get('last4SSN').setValue('');
            this.memberSearchForm.updateValueAndValidity();
        }
    }

    public search(): void {
        const l_MemberSearchPayload = new MemberSearchPayload();
        l_MemberSearchPayload.agentID = this.sessionService.session.agent.agentID;
        l_MemberSearchPayload.isPrimaryQ = true;
        l_MemberSearchPayload.companyID = this.companySearchForm.get('companyID').value ? this.companySearchForm.get('companyID').value : 0;
        l_MemberSearchPayload.lastNameQ = this.memberSearchForm.get('lastName').value;
        l_MemberSearchPayload.firstNameQ = this.memberSearchForm.get('firstName').value;
        l_MemberSearchPayload.employeeIDQ = this.memberSearchForm.get('erid').value;
        l_MemberSearchPayload.systemNumberQ = this.memberSearchForm.get('systemId').value ? this.memberSearchForm.get('systemId').value : 0;
        l_MemberSearchPayload.ssnQ = this.memberSearchForm.get('ssn').value;
        l_MemberSearchPayload.last4SSNQ = this.memberSearchForm.get('last4SSN').value;

        if (!l_MemberSearchPayload.companyID)
            l_MemberSearchPayload.companyID = 0;

        this.emitSearchPayload.emit(l_MemberSearchPayload);
    }
}